<div class="service-request-shell">
    <div class="container fw-b wrapper-content">
        <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
    </div>

    <!-- Hero (aligned with Service Order Detail / Transaction History layout) -->
    <section class="container transaction-hero">
        <div class="hero-container-card">
            <div class="hero-cards-wrapper">
                <div class="hero-stat-card wallet-card">
                    <div class="card-accent-strip wallet-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper wallet-icon">
                            <i class="fa fa-list-ul" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">
                            {{ count || 0 }}
                        </p>
                        <label class="stat-label">BOOKINGS IN VIEW</label>
                    </div>
                </div>
                <div class="hero-stat-card earning-card">
                    <div class="card-accent-strip earning-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper earning-icon">
                            <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">
                            {{ btn == 'Pending' ? 'Pending Bookings' : 'Completed Bookings' }}
                        </p>
                        <label class="stat-label">CURRENT VIEW</label>
            </div>
                </div>
                <div class="hero-stat-card commission-card">
                    <div class="card-accent-strip commission-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper commission-icon">
                            <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">
                            {{ headingName || 'My Bookings' }}
                        </p>
                        <label class="stat-label">BOOKING CONTEXT</label>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Tabs -->
    <section class="container order-tabs">
        <div class="row g-3">
            <div class="col-sm-6">
                <button class="tabBtn" [ngClass]="{active : btn == 'Pending'}" (click)="selectBtn('Pending')">
                    <span>Pending</span>
                </button>
            </div>
            <div class="col-sm-6">
                <button class="tabBtn" [ngClass]="{active : btn == 'Complete'}" (click)="selectBtn('Complete')">
                    <span>Completed</span>
                </button>
            </div>
        </div>
    </section>

    <section class="container table-wrapper">
        <!-- Pending table -->
        <article class="order-table-card" *ngIf="btn == 'Pending'">
            <div class="table-header">
                <div>
                    <p class="section-eyebrow">Pending Bookings</p>
                    <h2>Bookings awaiting action</h2>
                </div>
                <span class="badge-counter">{{ count || 0 }} bookings</span>
            </div>

            <div class="table-responsive">
                <table class="table modern-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Customer Name</th>
                            <th>Service Id</th>
                            <th>Booked At</th>
                            <th>Service Date</th>
                            <th>Category</th>
                            <th>Order Status</th>
                            <th>Payment Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of orderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index;">
                            <td>{{10 * (currentPage - 1) + i+1}}</td>
                            <td>{{item?.userId?.firstName}} {{item?.userId?.lastName}}</td>
                            <td>{{item?.orderId}}</td>
                            <td>{{formatBookedDateTime(item?.createdAt)}}</td>
                            <td>{{formatServiceDateTime(item?.duration, item?.slots[0])}}</td>
                            <td>{{item?.myOrders[0]?.serviceId?.categoryId?.categoryName}}</td>
                            <td>
                                <span class="status-chip" [ngClass]="getServiceStatusClass(item?.serviceStatus)">
                                    {{formatServiceStatus(item?.serviceStatus)}}
                                </span>
                            </td>
                            <td>
                                <span class="status-chip" [ngClass]="getPaymentStatusClass(item?.paymentStatus)">
                                    {{item?.paymentStatus || '--'}}
                                </span>
                            </td>
                            <td class="text-center">
                                <button class="ghost-link"
                                    [queryParams]="{_id: item?._id, status: item?.orderStatus}"
                                    [routerLink]="['/service-provider-request-services-view']">
                                    View
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <app-table-loader [isTable]="'TABLE'" [isLoading]="isLoading" [notFoundData]="notFoundData"
                [colspan]="10" [isWidth]="'80px'"></app-table-loader>
            <div class="table-footer" *ngIf="count > 10">
                <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
            </div>
        </article>

        <!-- Complete table -->
        <article class="order-table-card" *ngIf="btn == 'Complete'">
            <div class="table-header">
                <div>
                    <p class="section-eyebrow">Completed Bookings</p>
                    <h2>Completed & fulfilled</h2>
                </div>
                <span class="badge-counter">{{ count || 0 }} bookings</span>
            </div>

            <div class="table-responsive">
                <table class="table modern-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Customer Name</th>
                            <th>Service Id</th>
                            <th>Booked At</th>
                            <th>Service Date</th>
                            <th>Category</th>
                            <th>Order Status</th>
                            <th>Payment Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of orderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index;">
                            <td>{{10 * (currentPage - 1) + i+1}}</td>
                            <td>{{item?.userId?.firstName}} {{item?.userId?.lastName}}</td>
                            <td>{{item?.orderId}}</td>
                            <td>{{formatBookedDateTime(item?.createdAt)}}</td>
                            <td>{{formatServiceDateTime(item?.duration, item?.slots[0])}}</td>
                            <td>{{item?.myOrders[0]?.serviceId?.categoryId?.categoryName}}</td>
                            <td>
                                <span class="status-chip" [ngClass]="getServiceStatusClass(item?.serviceStatus)">
                                    {{formatServiceStatus(item?.serviceStatus)}}
                                </span>
                            </td>
                            <td>
                                <span class="status-chip" [ngClass]="getPaymentStatusClass(item?.paymentStatus)">
                                    {{item?.paymentStatus || '--'}}
                                </span>
                            </td>
                            <td class="text-center">
                                <button class="ghost-link"
                                    [queryParams]="{_id: item?._id, status: item?.orderStatus}"
                                    [routerLink]="['/service-order-detail-view']">
                                    View
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <app-table-loader [isTable]="'TABLE'" [isLoading]="isLoading" [notFoundData]="notFoundData"
                [colspan]="10" [isWidth]="'80px'"></app-table-loader>
            <div class="table-footer" *ngIf="count > 10">
                <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
            </div>
        </article>
    </section>
</div>
